import FuelPriceOptionViewModel from "@affinity/Store/FuelPriceOptionViewModel";
import ServiceBase from "@affinity/Store/ServiceBase";
import { HarrierPricingItemModel, HarrierPricingModel } from "@affinity/Store/StoreTypes";
import logger from "@insite/client-framework/Logger";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { getShipTos } from "@insite/client-framework/Services/CustomersService";
import { CartLineModel, OrderCollectionModel, OrderLineModel, ShipToCollectionModel } from "@insite/client-framework/Types/ApiModels";

class ServiceAccounts extends ServiceBase {
    getOrdersShipTo(value: CartLineModel | OrderLineModel) {
        try {
            return this.GetCustomPropertyValue(value, this.CustomPropertyNames.Orders.shipTo);
        } catch (error) {
            logger.warn(`Error accessing custom property Orders shipTo: ${error}`);
            return undefined;
        }
    }

    getHarrierPricingInfo(value: CartLineModel | OrderLineModel) {
        try {
            const raw = this.GetCustomPropertyValue(value, this.CustomPropertyNames.Orders.pricingInfo);
            return raw as HarrierPricingItemModel;
        } catch (error) {
            logger.warn(`Error accessing custom property Orders pricingInfo: ${error}`);
            return undefined;
        }
    }

    getAddresses(billToId: string) {
        return get<ShipToCollectionModel>(`${this.billTosUrl}/${billToId}/shiptos`, {
            billToId,
            exclude: "showAll",
        } as ApiParameter);
    }

    async getOrderHistoryAll() {
        // first request to get the order amount, second gets all orders in one page 
        const ordersAmount = await get<OrderCollectionModel>(this.orderHistory, {
            pageSize: 1,
            customerSequence: -1,
            expand: 'orderLines',
        } as ApiParameter ).then((res) => res.pagination?.totalItemCount)
        return get<OrderCollectionModel>(this.orderHistory, {
            customerSequence: -1,
            expand: 'orderLines',
            sort: "orderDate DESC, erpOrderNumber DESC",
            pageSize: ordersAmount,
        } as ApiParameter);
    }

    async getShipToByErp(billToId: string, shipToErp: string) {
        const shipToCollection = await this.getAddresses(billToId);
        return shipToCollection?.shipTos?.find(s => s.customerSequence === shipToErp);
    }

    // TODO NEW AFFINITY METHOD VERSIONS AS WILL USE CART SHIPTO AND NOT USE CUSTOM PROPERTY ***
}

export default ServiceAccounts;